import { render, staticRenderFns } from "./clientModalBasic.vue?vue&type=template&id=4ee21fdd&scoped=true&"
import script from "./clientModalBasic.vue?vue&type=script&lang=js&"
export * from "./clientModalBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee21fdd",
  null
  
)

export default component.exports